import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class contractObjectService {

    constructor(private http: HttpClient) { }

    async getContractObjectsFuecs() {
        let response = await this.http.get<any>('/api/fuec/contract_object').toPromise();
        if (response.contract_objects) {
            return response.contract_objects
        } else {
            return null;
        }
    }

    async getContractObjectsFuecById(id: string) {
        let response = await this.http.get<any>('/api/fuec/contract_object/' + id).toPromise();
        if (response.contract_object) {
            return response.contract_object
        } else {
            return null;
        }
    }
}